'use client';

import Link from 'next/link';
import { useState } from 'react';
import { toast } from 'react-toastify';
import validator from 'validator';
import { useAuth } from '@/app/components/AuthContext';
import { showLoader } from '@/app/helper/common_helper';
import { Tooltip } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';

const Login = () => {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    
    const handleLogin = async (e : any) => {
        e.preventDefault();
        if (!validator.isEmail(email)) {
            toast.error('Invalid email address.');
            return;
        }
        if (password.length < 3) {
            toast.error('Password must be at least 3 characters.');
            return;
        }
        
        showLoader(true, 'Logging in...');
        try {
            await login({ email, password });
        } catch (err : any) {
            toast.error(err.message);
        }
        showLoader(false);
    }

    return (
        <>
            <h3 className="px_auth_title">Welcome Back!</h3>
            <p className="px_auth_subtitle">Please enter your credentials to login.</p>
            <form onSubmit={handleLogin}>
                <div className="px_input_wrapper">
                    <input className="px_input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                </div>
                <div className="px_input_wrapper">
                    <input className="px_input" value={password} onChange={(e) => setPassword(validator.trim(e.target.value))} type={`${showPassword ? "text" : "password"}`} placeholder="Password" required />
                    <Tooltip title={`${showPassword ? "Hide" : "Show"}`} arrow placement="top">
                        <span className="px_password_show_hide" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff size={16} /> : <Eye size={16} />}</span>
                    </Tooltip>
                </div>
                <div className="px_auth_forgot">
                    <Link href="/forgot-password">Forgot Password?</Link>
                </div>
                <button className="px_btn px_btn_block !py-3" onClick={(e) => handleLogin(e)} >Login</button>
                <div className="px_auth_footer">
                    <p>Don&apos;t have an account? <Link href="/signup">Sign Up</Link></p>
                </div>
            </form>
        </>
    );
}

export default Login;